import React, { Component } from "react";
import { observer } from "mobx-react";
import { Segment, Header, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import Immersive3dTour from "~/models/Immersive3dTour/Immersive3dTour";

@observer
class DeniedSection extends Component {
  render() {
    const { immersive3dTour, deleteImmersive3dTourCallback } = this.props;

    return (
      <Segment placeholder textAlign="center">
        <Header icon>
          <Icon name="times circle" />
          Sorry, we could not process your Immersive 3D Tour
        </Header>
        <Segment.Inline>
          <p>{immersive3dTour.deniedMessage}</p>
          <p>
            Would you like to try again with different/new 360 panoramas?{" "}
            <a onClick={() => deleteImmersive3dTourCallback()}>Click here to delete the existing Immersive 3D Tour</a>
          </p>
        </Segment.Inline>
      </Segment>
    );
  }
}

DeniedSection.propTypes = {
  immersive3dTour: PropTypes.instanceOf(Immersive3dTour),
  deleteImmersive3dTourCallback: PropTypes.func.isRequired,
};

export default DeniedSection;
